import { SvgIconProps, Theme } from '@mui/material';
import {
  WandStartIcon,
  FloppyDishClockIcon,
  LogoIcon,
  WalletIcon,
} from "../components/ui/icons";
import { ROUTES } from './routes';

export interface BaseMenuItem {
  key: string;
  path: string;
  translationKey: string;
  badge?: string;
  onClick?: () => void;
  href?: string;
  hidden?: boolean;
  textStyle?: React.CSSProperties;
}

export interface BasicNavItem extends BaseMenuItem {
  type: 'basic';
}

export type MenuItem = BasicNavItem;

export const basicNavItems: BasicNavItem[] = [
  {
    key: 'overview',
    type: 'basic',
    path: ROUTES.OVERVIEW,
    translationKey: 'bottomNav.overview',
  },
  {
    key: 'assets',
    type: 'basic',
    path: ROUTES.ASSETS,
    translationKey: 'bottomNav.assets',
  },
  {
    key: 'budget',
    type: 'basic',
    path: ROUTES.BUDGET,
    translationKey: 'bottomNav.budget',
  },
  {
    key: 'history',
    type: 'basic',
    path: ROUTES.HISTORY,
    translationKey: 'bottomNav.history',
  },
];

export const allMenuItems: MenuItem[] = [...basicNavItems];


// Icon configuration function that returns component and props
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const getMenuItemIconConfig = (itemKey: string, _theme: Theme) => {
  const iconConfigs: Record<string, { component: React.ComponentType<SvgIconProps>; props: SvgIconProps }> = {
    overview: { component: LogoIcon, props: { style: { fontSize: 27 } } },
    assets: { component: WalletIcon, props: { style: { fontSize: 27 } } },
    budget: { component: WandStartIcon, props: { style: { fontSize: 27 } } },
    history: { component: FloppyDishClockIcon, props: { style: { fontSize: 27 } } },
  };

  return iconConfigs[itemKey];
};
